export default __webpack_public_path__ + "static/media/aerospace.7b985904.png";